import React from 'react'
import WrapIcon from '../../elements/WrapIcon'
import IconClose from '../../../assets/icons/IconClose'
import FormatCurrency from '../../elements/FormatCurrency'
import Modal from '../../common/modal'
import InputFill from '../../form/InputFill'

import { FOOD_KIND } from '../../../constants'
import { getFoodPriceShow } from '../../../utils'
import useMoney from '../../../hooks/useMoney'
import { useTranslation } from 'react-i18next'

const FoodItemSearch = ({ item, ...props }) => {
    const { currentPrice, originPrice } = useMoney(getFoodPriceShow, item)
    return (
        <div className="food-search__results__item" {...props} >
            <div className="food-search__results__item__info-left">
                <div className="name">{item.pdaName || item.name}</div>
            </div>
            {item.kind === FOOD_KIND.NORMAL && (
                <div className="food-search__results__item__price ml-2">
                    <FormatCurrency amount={originPrice || currentPrice} />
                </div>
            )}
        </div>
    )
}

const FoodSearch = props => {
    const {
        setKeyword,
        keyword,
        listFood,
        showBoxSearch,
        setShowBoxSearch,
        onSelectFood,
    } = props

    const { t } = useTranslation()

    return (
        <>
            <Modal
                isOpen={showBoxSearch}
                overlayClassName="modal-food-search__overlay"
            >
                <div className="modal-food-search">
                    <div className="container-fluid">
                        <form className="modal-food-search__search-box">
                            <InputFill
                                autoFocus
                                value={keyword}
                                onChange={e => setKeyword(e.target.value)}
                            />

                            <WrapIcon
                                onClick={() => setShowBoxSearch(false)}
                                size="18px"
                                icon={IconClose}
                                className="icon-close"
                                color="000000"
                            />
                        </form>

                        <div className="food-search__results">
                            {listFood.map((el, index) => (
                                <FoodItemSearch
                                    key={index}
                                    item={el}
                                    onClick={() => onSelectFood(el)}
                                />
                            ))}
                        </div>
                    </div>
                </div>
            </Modal>

            <div className="mobile search__input">
                <InputFill
                    placeholder={t('headerMobile.lbSearchFood')}
                    readOnly
                    className="pointer"
                    onClick={() => setShowBoxSearch(true)}
                />
            </div>
        </>
    )
}

export default FoodSearch
